export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {

	// loadMoreNews(jQuery('.blog-container'));

	// blogFilter();
	
	// jQuery('.categories-select.nice-select li').bind('click', function() {
	// 	console.log('test');
	// 	// blogFilterMobile(jQuery(this));
	// });
	/*function blogFilter() {
		jQuery('.blog-sidebar a').on('click', function(e){
			e.preventDefault();
			jQuery('.blog-container').addClass('hide-blog');
			jQuery('.blog-container-filter').addClass('hide-blog');
			jQuery('.load-more-container').hide();
			jQuery('.loading-icon').addClass('show');
			jQuery('.blog-sidebar li').each(function() {
				jQuery(this).removeClass('active');
			});
			jQuery(this).parent().addClass('active');
			let $tag = jQuery(this).attr('data-tag');
			let $cat = jQuery(this).attr('data-cat');
			if ($tag == 'all' || $cat == 'all') {
				jQuery('.blog-container').removeClass('hide-blog');
				jQuery('.blog-container-filter').addClass('hide-blog');
				jQuery('.loading-icon').removeClass('show');
				jQuery('a[data-tag="all"').parent().addClass('active');
				jQuery('a[data-cat="all"').parent().addClass('active');
				loadMoreNews(jQuery('.blog-container'));
				return;
			}
			if (typeof $tag == 'undefined') {
				var $filter = $cat;
				var $type = 'cat';
			} else if (typeof $cat == 'undefined') {
				var $filter = $tag;
				var $type = 'tag';
			}

			// console.log($filter);

			jQuery.ajax({
				data: {filter: $filter, type: $type},
				url: '/wp-content/themes/henderson_bros/src/lib/blog-news-filter.php',
				success: function(response) {
					jQuery('.blog-container-filter').html(response);
					loadMoreNews(jQuery('.blog-container-filter'));
				},
				complete: function() {
					jQuery('.loading-icon').removeClass('show');
					jQuery('.blog-container-filter').removeClass('hide-blog');
					console.log('done');
				} 
			});
		});
	}*/

	// function blogFilter() {
	// 	jQuery('.blog-sidebar a').on('click', function(e){
	// 		e.preventDefault();
	// 		let $curTag = jQuery('.cur-filters .tag').text();
	// 		let $curCat = jQuery('.cur-filters .cat').text();
	// 		// console.log($curCat);
	// 		// console.log($curTag);
	// 		let $tag = jQuery(this).attr('data-tag');
	// 		let $cat = jQuery(this).attr('data-cat');

	// 		if ($curTag.length > 1 && $tag == undefined && $tag != 'all') {
	// 			$tag = $curTag;
	// 		} 

	// 		if ($curCat.length > 1 && $cat == undefined && $cat != 'all') {
	// 			$cat = $curCat;
	// 		}
	// 		// console.log($curTag);
	// 		// console.log($tag);
	// 		// console.log($curCat);
	// 		// console.log($cat);

	// 		jQuery('.blog-container').addClass('hide-blog');
	// 		jQuery('.blog-container-filter').addClass('hide-blog');
	// 		jQuery('.load-more-container').hide();
	// 		jQuery('.loading-icon').addClass('show');

	// 		jQuery('.blog-sidebar li').each(function() {
	// 			jQuery(this).removeClass('active');
	// 		});

	// 		// console.log(jQuery('.blog-sidebar li a[data-cat='+$cat+']'));
	// 		// console.log(jQuery('.blog-sidebar li a[data-cat='+$tag+']'));

	// 		jQuery('.blog-sidebar li a[data-cat='+$cat+']').parent().addClass('active');
	// 		jQuery('.blog-sidebar li a[data-tag='+$tag+']').parent().addClass('active');

	// 		// jQuery(this).parent().addClass('active');
	// 		// if ($tag == 'all' || $cat == 'all') {
	// 		// 	jQuery('.blog-container').removeClass('hide-blog');
	// 		// 	jQuery('.blog-container-filter').addClass('hide-blog');
	// 		// 	jQuery('.loading-icon').removeClass('show');
	// 		// 	jQuery('a[data-tag="all"').parent().addClass('active');
	// 		// 	jQuery('a[data-cat="all"').parent().addClass('active');
	// 		// 	loadMoreNews(jQuery('.blog-container'));
	// 		// 	return;
	// 		// }

	// 		// if (typeof $tag == 'undefined') {
	// 		// 	var $filter = $cat;
	// 		// 	var $type = 'cat';
	// 		// } else if (typeof $cat == 'undefined') {
	// 		// 	var $filter = $tag;
	// 		// 	var $type = 'tag';
	// 		// }

	// 		// console.log($filter);

	// 		jQuery.ajax({
	// 			data: {cat: $cat, tag: $tag},
	// 			url: '/wp-content/themes/henderson_bros/src/lib/blog-news-filter.php',
	// 			success: function(response) {
	// 				jQuery('.blog-container-filter').html(response);
	// 				loadMoreNews(jQuery('.blog-container-filter'));
	// 			},
	// 			complete: function() {
	// 				jQuery('.loading-icon').removeClass('show');
	// 				jQuery('.blog-container-filter').removeClass('hide-blog');
	// 				console.log('done');
	// 			} 
	// 		});
	// 	});
	// }
	
	// function loadMoreNews($container) {
	// 	let $newsArray = $container.find('.blog-row').toArray();
	// 	// console.log($newsArray);
	// 	let OgArrayLength = $newsArray.length;
	// 	$container.find('.blog-row').hide();
	// 	$container.find('.blog-row:lt(3)').show();
	// 	// $('#showLess').hide();
	// 	let items =  OgArrayLength;
	// 	let shown =  3;
	// 	if (items > shown) {
	// 		jQuery('.load-more-container').show();
	// 	}
	// 	// if (items = shown) {jQuery('.load').parent().hide();}
	// 	jQuery('.load').click(function (e) {
	// 		e.preventDefault();
	// 		// $('#showLess').show();
	// 		shown = $container.find('.blog-row:visible').size()+3;
	// 		if(shown < items) {
	// 			$container.find('.blog-row:lt('+shown+')').show();
	// 		} else {
	// 			$container.find('.blog-row:lt('+items+')').show();
	// 		    jQuery('.load-more-container').hide();
	// 		}
	// 	});
	// }

	// function blogFilterMobile($filter) {
	// 	// jQuery('.list li').on('click', function(e){
 //            var selectedCat = $filter.text();
 //            selectedCat = $filter.replace(' ', '-');
 //            selectedCat = $filter.toLowerCase();

 //            console.log(selectedCat);

 //            // var selectedTag = jQuery(this).text();
 //            // selectedTag = selectedTag.replace(' ', '-');
 //            // selectedTag = selectedTag.toLowerCase();

 //            // console.log(selectedTag);
 //        //     // var selectedTitle = jQuery('.categories-select.nice-select .current').text();
 //        //     console.log(selectedCat);
 //        //     // console.log(selectedTitle);
 //        // });
	// 	// if (jQuery('.list li').hasClass('selected')){
	// 		// e.preventDefault();
	// 		jQuery('.blog-container').addClass('hide-blog');
	// 		jQuery('.blog-container-filter').addClass('hide-blog');
	// 		jQuery('.load-more-container').hide();
	// 		jQuery('.loading-icon').addClass('show');
	// 		// jQuery('.blog-sidebar li').each(function() {
	// 		// 	jQuery(this).removeClass('active');
	// 		// });
	// 		// jQuery(this).parent().addClass('active');
	// 		let $tag = jQuery(this).attr('data-tag');
	// 		let $cat = jQuery(this).attr('data-cat');
	// 		if ($tag == 'all' || $cat == 'all') {
	// 			jQuery('.blog-container').removeClass('hide-blog');
	// 			jQuery('.blog-container-filter').addClass('hide-blog');
	// 			jQuery('.loading-icon').removeClass('show');
	// 			jQuery('a[data-tag="all"').parent().addClass('active');
	// 			jQuery('a[data-cat="all"').parent().addClass('active');
	// 			loadMoreNews(jQuery('.blog-container'));
	// 			return;
	// 		}
	// 		if (typeof $tag == 'undefined') {
	// 			var $filter = $cat;
	// 			var $type = 'cat';
	// 		} else if (typeof $cat == 'undefined') {
	// 			var $filter = $tag;
	// 			var $type = 'tag';
	// 		}

	// 		// console.log($filter);

	// 		jQuery.ajax({
	// 			data: {filter: $filter, type: $type},
	// 			url: '/app/themes/henderson_bros/src/lib/blog-news-filter.php',
	// 			success: function(response) {
	// 				jQuery('.blog-container-filter').html(response);
	// 				loadMoreNews(jQuery('.blog-container-filter'));
	// 			},
	// 			complete: function() {
	// 				jQuery('.loading-icon').removeClass('show');
	// 				jQuery('.blog-container-filter').removeClass('hide-blog');
	// 				console.log('done');
	// 			} 
	// 		});
	// 	// }
	// 	// });
	// }

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/Blog.js